import { Checkbox, Text, VisuallyHidden } from '@vtex/admin-ui'
import {
  FormState,
  getErrorText,
  hasError,
  useWatch,
} from '@vtex/admin-ui-form'
import { useNumbers } from '../../../../utils/useNumbers'
import { FieldDetails } from '../../../../FieldDetails'
import { styles } from './styles'
import { FormattedMessage } from 'react-intl'
import { messages } from './messages'

const THRESHOLD_OPTIONS = [75, 80, 85, 90, 95, 100] as const

type ThresholdsInputProps = {
  name: string
  form: FormState
}

export function ThresholdsInput(props: ThresholdsInputProps) {
  const { name, form } = props
  const { formatPercentual } = useNumbers()

  const thresholds: number[] = useWatch({ form, name })

  const toggleThreshold = (value: number) => {
    const next = thresholds.includes(value)
      ? thresholds.filter((t) => t !== value)
      : [...thresholds, value].sort((a, b) => a - b)

    form.setValue(name, next)
    form.clearErrors(name)
  }

  return (
    <div>
      <div
        className={styles.thresholdsContainer}
        data-error={hasError(form, name)}
      >
        <Text tone="secondary" variant="detail">
          <FormattedMessage {...messages.notifyAt} />
        </Text>
        <div className={styles.thresholdsInput}>
          <div className={styles.thresholdsList}>
            {THRESHOLD_OPTIONS.map((threshold) => {
              const percentLabel = formatPercentual(Number(threshold))
              const isChecked = thresholds.includes(threshold)

              return (
                <div className={styles.thresholdItem} key={threshold}>
                  <Checkbox
                    className={styles.checkbox}
                    checked={isChecked}
                    label={<VisuallyHidden>{percentLabel}</VisuallyHidden>}
                    onChange={() => toggleThreshold(threshold)}
                  />
                  <Text
                    tone={isChecked ? 'primary' : 'secondary'}
                    variant="body"
                  >
                    {percentLabel}
                  </Text>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <FieldDetails>
        <FieldDetails.Error text={getErrorText(form, name)} />
      </FieldDetails>
    </div>
  )
}
